import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-ink-950/80 py-10 text-sm text-slate-400">
      <div className="container-page flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
        <div>
          <div className="text-slate-200 font-medium">Community Shield OS</div>
          <p className="mt-1 max-w-md text-slate-400">
            Built with community oversight. Reports are reviewed before they
            become public alerts. We do not run facial recognition or share
            personal data.
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2">
          <Link className="hover:text-white" to="/privacy">
            Privacy & Trust
          </Link>
          <Link className="hover:text-white" to="/resources">
            Safety resources
          </Link>
          <Link className="hover:text-white" to="/request-access">
            Request access
          </Link>
        </nav>
      </div>
    </footer>
  );
}
